import React from 'react';
import moment from 'moment';
import withRouter from '../constants/withRouter';
import GetORPostAsync from '../constants/restservice';
import { toast } from 'react-toastify';

class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.UpdateProfileDetails = this.UpdateProfileDetails.bind(this);
        this.state = {
            steps: "1",
            account_number: "",
            bank_name: "",
            branch_name: "",
            DOB: "",
            fullname: "",
            ifsc: "",
            MemberID: "",
            Pan: "",
            aadhar: "",
            address1: "",
            address2: "",
            address3: "",
            city: "",
            country: "",
            district: "",
            email: "",
            mobile: "",
            nmname: "",
            nmrelation: "",
            checkname: "",
            sex: "",
            state: "",
            zipcode: "600093"
        }
    }
    componentDidMount() {
        this.GetProfileDetails();
    }
    async GetProfileDetails() {
        let res = await GetORPostAsync("MyProfile.asp", "GET", null, localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                this.props.history.push("/login");
            }
            return;
        }
        console.log(res);
        this.setState(res);
        this.setState({
            steps: "1",
            DOB: res.DOB ? moment(res.DOB).format("yyyy-MM-DD") : ""
        })
    }
    async UpdateProfileDetails() {
        let json_input = {
            account_number: this.state.account_number,
            bank_name: this.state.bank_name,
            branch_name: this.state.branch_name,
            dob: moment(this.state.DOB).format("MM/DD/yyyy"),
            sex: this.state.sex,
            address1: this.state.address1,
            address2: this.state.address2,
            address3: this.state.address3,
            fulladdress: this.state.address3,
            city: this.state.city,
            district: this.state.city,
            state1: this.state.state,
            state: this.state.state,
            country: this.state.country,
            zipcode: this.state.zipcode,
            nmname: this.state.nmname,
            nmrelation: this.state.nmrelation,
            checkname: this.state.checkname,
            ifsc: this.state.ifsc
        }
        let res = await GetORPostAsync("editprofile.asp", "POST", JSON.stringify(json_input), localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                this.props.history.push("/login");
            }
            return;
        }
        toast(res.message);
        await this.GetProfileDetails();
    }
    render() {
        return (
            <div>
                <div className="row py-5">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                        <div className="card overflow-hidden dash1-card border-0 ">
                            <div className="btn-group btn-group-toggle mt-2 ml-auto mr-auto" data-toggle="buttons">
                                <label className={`btn ${this.state.steps === "1" ? "btn-color-2" : "btn-color-1"}`} onClick={(e) => {
                                    this.setState({
                                        steps: "1",
                                    })
                                }}>1 Personal
                                </label>
                                <label className={`btn ${this.state.steps === "2" ? "btn-color-2" : "btn-color-1"}`} onClick={(e) => {
                                    this.setState({
                                        steps: "2",
                                    })
                                }}>2 Address
                                </label>
                                <label className={`btn ${this.state.steps === "3" ? "btn-color-2" : "btn-color-1"}`} onClick={(e) => {
                                    this.setState({
                                        steps: "3",
                                    })
                                }}>3 Bank
                                </label>
                            </div>
                            <div className="card-body" style={{ display: this.state.steps === "1" ? "block" : "none" }}>
                                <h5 className=" mt-3 mb-3">Profile</h5>
                                <div className="search-element row mb-5">
                                    <label className='form-label'>Full name</label>
                                    <div className="input-container">
                                        <i className="las la-user inputicon"></i>
                                        <input type="search" className="col-lg-6 form-control" placeholder="FullName" aria-label="FullName" tabIndex="1" readOnly value={this.state.fullname} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <label className='form-label'>Mobile</label>
                                    <div className="input-container">
                                        <i className="las la-mobile inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="Mobile" aria-label="Mobile" tabIndex="1" readOnly value={this.state.mobile} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <label className='form-label'>Email</label>
                                    <div className="input-container">
                                        <i className="las la-envelope inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="Email" aria-label="Email" tabIndex="1" readOnly value={this.state.email} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <label className='form-label'>Date of Birth</label>
                                    <div className="input-container">
                                        <i className="las la-calendar inputicon"></i>
                                        <input type="date" className="col-lg-6 form-control" placeholder="DOB" aria-label="DOB" tabIndex="1" onChange={(e) => this.setState({ DOB: e.target.value })} value={this.state.DOB} />
                                    </div>
                                </div>
                                {/* <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-transgender-alt inputicon"></i>
                                        <select className="col-lg-6 form-control" value={this.state.sex} onChange={(e) => {
                                            this.setState({
                                                sex: e.target.value
                                            })
                                        }} >
                                            <option value="">--Select Gender --</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="others">Others</option>
                                        </select>
                                    </div>
                                </div> */}
                                <button className="ml-2 mb-5 btn btn-primary" onClick={(e) => {
                                    this.UpdateProfileDetails();
                                }}>Update</button>
                            </div>

                            <div className="card-body" style={{ display: this.state.steps === "2" ? "block" : "none" }}>
                                <h5 className=" mt-3 mb-3">Address</h5>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-address-card inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="address1" aria-label="address1" tabIndex="1" value={this.state.address1} onChange={(e) => {
                                            this.setState({
                                                address1: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-road inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="address2" aria-label="address2" tabIndex="1" value={this.state.address2} onChange={(e) => {
                                            this.setState({
                                                address2: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-street-view inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="address3" aria-label="address3" tabIndex="1" value={this.state.address3} onChange={(e) => {
                                            this.setState({
                                                address3: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-city inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="City" aria-label="City" tabIndex="1" value={this.state.city} onChange={(e) => {
                                            this.setState({
                                                city: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-map inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="state" aria-label="state" tabIndex="1" value={this.state.state} onChange={(e) => {
                                            this.setState({
                                                state: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-flag inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="Country" aria-label="Country" tabIndex="1" value={this.state.country} onChange={(e) => {
                                            this.setState({
                                                country: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-map-marker inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="zipcode" aria-label="zipcode" tabIndex="1" value={this.state.zipcode} onChange={(e) => {
                                            this.setState({
                                                zipcode: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <button className="ml-2 mb-5 btn btn-primary" onClick={(e) => {
                                    this.UpdateProfileDetails();
                                }}>Update</button>
                            </div>

                            <div className="card-body" style={{ display: this.state.steps === "3" ? "block" : "none" }}>
                                <h5 className=" mt-3 mb-3">Bank Details</h5>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-address-card inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="Account holder name" aria-label="checkname" tabIndex="1" value={this.state.checkname} onChange={(e) => {
                                            this.setState({
                                                checkname: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-file-invoice inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="Account number" aria-label="account_number" tabIndex="1" value={this.state.account_number} onChange={(e) => {
                                            this.setState({
                                                account_number: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-landmark inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="Bank name" aria-label="bank_name" tabIndex="1" value={this.state.bank_name} onChange={(e) => {
                                            this.setState({
                                                bank_name: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-code-branch inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="Branchname" aria-label="branchname" tabIndex="1" value={this.state.branch_name} onChange={(e) => {
                                            this.setState({
                                                branch_name: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-envelope inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="IFSC" aria-label="IFSC" tabIndex="1" value={this.state.ifsc} onChange={(e) => {
                                            this.setState({
                                                ifsc: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-user-plus inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="Nominee name" aria-label="nmname" tabIndex="1" value={this.state.nmname} onChange={(e) => {
                                            this.setState({
                                                nmname: e.target.value
                                            })
                                        }} />
                                    </div>
                                </div>
                                {/* <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-user-plus inputicon"></i>
                                        <input type="text" className="col-lg-6 form-control" placeholder="Nominee relationship" aria-label="nmrelation" tabIndex="1" value={this.state.nmrelation} />
                                    </div>
                                </div> */}
                                <div className="search-element row mb-5">
                                    <div className="input-container">
                                        <i className="las la-heart inputicon"></i>
                                        <select readOnly={true} className="col-lg-6 form-control" value={this.state.nmrelation} onChange={(e) => {
                                            this.setState({
                                                nmrelation: e.target.value
                                            })
                                        }} >
                                            <option value="">-- Select nominee relation --</option>
                                            <option value="Father">Father</option>
                                            <option value="Mother">Mother</option>
                                            <option value="Wife">Wife</option>
                                            <option value="Husband">Husband</option>
                                            <option value="Brother">Brother</option>
                                            <option value="Sister">Sister</option>
                                            <option value="Son">Son</option>
                                            <option value="Daughter">Daughter</option>
                                        </select>
                                    </div>
                                </div>
                                <button className="ml-2 mb-5 btn btn-primary" onClick={(e) => {
                                    this.UpdateProfileDetails();
                                }}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(Profile);